export enum DocumentManagementTab {
  all,
  credit
}
